<template>
  <div id="register">
    <div :class="['app-container', urlParams.direction]">
      <div class="body">
        <router-view />
      </div>

      <transition
        name="fade"
        mode="out-in"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
// TODO: DGC-27954 restore code

import { RouteRecordRaw, useRoute } from 'vue-router';
import { computed, getCurrentInstance } from 'vue';
import { app } from '@/main';
import { DEFAULT_LOCALE } from '@/modules/login/shared/store/constants';
// TODO: DGC-27954 restore code
import { RouteProvider } from '@/modules/navigation/providers/route.provider';
import { ManifestService, ThemeService, storageService } from '@/shared/services';
import store from '@/store';
import { configs } from '@/shared/configs';
import { Page404 } from '@/components';
import { DefaultValuesService } from './modules/RegistrationPage/services/default-values.service';
import UrlParserService from './modules/RegistrationPage/services/url-parser.service';
import { IRequiredRegistrationPropertiesConfig } from './modules/RegistrationPage/store/types';
import { useWorkflowManager } from '@/shared/helpers/helpers';
import { updateLocal } from '@/shared/helpers/utils';

const urlParams = computed(() => store.getters['registration/config/urlParams']);
const organizationConfig = computed(() => store.getters['registration/config/organizationConfig']);

async function getPageTheme(rrpConfig: IRequiredRegistrationPropertiesConfig) {
  const theme: string = rrpConfig.theme || organizationConfig.value.colorSchema;
  const themeService = new ThemeService(theme);

  await themeService.setVersion('v1').setTheme();
  app.config.globalProperties.$theme = themeService;
}

// TODO: DGC-10279. Temporary visual fix. Provide a universal handler.
document.body.classList.add('flow-register');
storageService.session.set(configs.REGISTER_PATH_KEY, useRoute().fullPath);
store.commit('registration/config/setUrlState', UrlParserService.parse(useRoute().query));

const { manifest } = await store.dispatch('registration/config/loadLinkInfo', urlParams.value.linkId);

await store.dispatch('registration/config/loadDynamicConfig');
await store.dispatch('registration/config/loadOrganizationConfig');

if (urlParams.value.testFlowId) {
  await store.dispatch('registration/config/loadTestFlow', {
    testCanonicalId: urlParams.value.testFlowId,
    locale: urlParams.value.lang || DEFAULT_LOCALE,
  });
} else {
  store.commit('registration/config/setPretestFlow');
}

const userLanguage = urlParams.value.lang || organizationConfig.value.defaultLanguageCode || DEFAULT_LOCALE;

const manifestService = new ManifestService(manifest, userLanguage, urlParams.value.baseConfigUrl);
const { locale: manifestLocale, rrp, ui } = await manifestService.rrpConfigs;
const routeProvider = RouteProvider.getInstance();

routeProvider.setRoutes(rrp.pages);
await store.dispatch('setLocale', userLanguage);
await store.dispatch('setDirection', urlParams.value.direction);
await store.dispatch('setHideIgentifyLogo', rrp.hideIgentifyLogo, { root: true });

storageService.session.set(configs.ORGANIZATION_LOGO_KEY, organizationConfig.value?.logo?.url);
await getPageTheme(rrp);

store.commit('registration/config/setRRP', rrp);

const state = DefaultValuesService.supplyValues(
  urlParams.value.initialValues,
  rrp.pages,
);

// TODO: workaround !!!
const payload = {
  data: {
    ...state,
  },
};

useWorkflowManager().compiler.hooks({
  beforeRoutesAdded: (routes: RouteRecordRaw[]) => [...routes, { path: '*', component: Page404, name: 'PageNotFound' }],
  onBuildCompleted: () => routeProvider.route(),
});

useWorkflowManager().setUiConfigs(ui);

useWorkflowManager().compiler
  .vueInstance(getCurrentInstance())
  .state(payload)
  .defaultGlobalProps({
    direction: urlParams.value.direction,
  })
  .build(rrp);

await updateLocal(manifest, userLanguage, urlParams.value.baseConfigUrl, manifestLocale);

</script>

<style lang="less">
.flow-register .NavBar {
  display: none;
}

.app-container {
  max-width:        1100px;
  flex:             1;
  background-color: var(--neutral--gabriel);
  box-shadow:       0 1px 1px 0 rgba(0, 0, 0, 0.14), 3px 4px 15px 0 rgba(0, 0, 0, 0.2);
  position:         relative;
}

.body {
  grid-area: body;
  height:    100%;
}

body {
  margin: 0;
}

.leonardo-launcher {
  left:  40px;
  right: auto;
}

.rtl {
  direction: rtl;
}
</style>
